import React from 'react';

function Terms() {
  return (
    <main>
      <section className="spacing">
        <div className="limit-width">
          <h1 className="centered golden main-heading mb26">Terms &amp; Conditions</h1>

<p><strong>Last updated:</strong> September 29, 2025</p>
          <p>
            By using the Bumpyourserver Bot {/*or visiting our website*/}, you agree to the terms outlined below. 
            Please read them carefully before continuing to use our services.
          </p>
          <h2>Key Terms and Definitions</h2>
          <ul>
            <li><strong>Bot</strong> – Refers to the Bumpyourserver Discord bot available through Discord.</li>
            <li><strong>Content</strong> – Any messages, ads, text, or other material that appears through our Services.</li>
            <li><strong>Service</strong> – The {/*Website or*/} Bot provided by us.</li>
            <li><strong>Third-party</strong> – Any external service, product, or content not operated by Bumpyourserver but accessible through or in connection with our Services.</li>
            <li><strong>We / Us / Our</strong> – Refers to Bumpyourserver.</li>
            {/* <li><strong>Website</strong> – Our official site: <a href="https://www.bumpyourserver.xyz/" target="_blank" rel="noopener noreferrer">https://www.bumpyourserver.xyz/</a>.</li> */}
            <li><strong>You / Your</strong> – Any individual or entity that accesses or uses our Services.</li>
          </ul>
          <h2>User Responsibilities</h2>
          <ul>
            <li>You must follow the Discord Terms of Service and respect the rules of any third-party services you use with our Bot.</li>
            <li>We are not liable for any issues, losses, or damages that may result from using our Services.</li>
            <li>We are not responsible for problems caused by external services linked or used with our Bot.</li>
            <li>You are fully responsible for how you use commands, settings, or data within the Bot. Misuse or abuse of the Service can result in a ban.</li>
            <li>Since the Bot is free, refunds or compensation are not available if a command does not function as expected.</li>
          </ul>
          <h2>User Rights</h2>
          <ul>
            <li>You may remove the Bot from your server at any time if you wish to stop using the Service.</li>
            <li>You may request access to the data we have collected about you.</li>
            <li>If you believe content shared through our Bot infringes on copyright, you may report it to us for removal.</li>
            <li>You may contact us for details about how your information is handled or stored.</li>
          </ul>
          <h2>Service Limitations</h2>
          <ul>
            <li>Our Services may be suspended, modified, or discontinued at any time without prior notice.</li>
            <li>
              We are not responsible for user-generated content (e.g., bump messages). Responsibility for that content lies 
              with the user who provided it. However, we may remove inappropriate content or suspend access if necessary.
            </li>
          </ul>
          <h2>Updates to the Terms</h2>
          <p>
            We may update or revise these Terms at any time. If changes are made, we will make reasonable efforts to notify users 
            at least 30 days before they take effect. What qualifies as a &quot;change&quot; will be determined at our discretion.
          </p>
          <p>
            By continuing to use our Services after changes are posted, you agree to the updated Terms. 
            If you do not agree, you must stop using our Services.
          </p>
          <h2>Contact Information</h2>
          <p>If you have any questions about these Terms, please reach out to us through one of the following:</p>
          <ul>
            <li>Email: <a href="mailto:bysbumpyourserver@gmail.com">bysbumpyourserver@gmail.com</a></li>
            <li>Discord: Support Server (open a ticket)</li>
          </ul>
        </div>
      </section>
    </main>
  );
}

export default Terms;
